import { render, staticRenderFns } from "./ViewInfoModal.vue?vue&type=template&id=4273061c&scoped=true&"
import script from "./ViewInfoModal.vue?vue&type=script&lang=js&"
export * from "./ViewInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewInfoModal.vue?vue&type=style&index=0&id=4273061c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4273061c",
  null
  
)

export default component.exports